import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'
import { Roles } from '@/constants/user/roles'

export default class JobRefundedChatMessage extends AbstractChatMessage {
  type = MessageTypes.JOB_REFUNDED
  body: {
    reason: string
  }

  constructor(data: LX.JobRefundedChatMessage) {
    super(data)
    this.body = data.body
  }

  static fromServer(data: LX.JobRefundedChatMessage) {
    return new JobRefundedChatMessage(data)
  }

  getShortMessage(userId: string, role: Roles) {
    const isOwn = this.sender === `${userId}:${role}`
    return isOwn ? 'You have requested a refund' : 'Customer requested a refund'
  }
}
